import api from './api';
import type { BidSummaryResponse } from '../types';

export const reportService = {
  generate: async (bidId: string): Promise<BidSummaryResponse> => {
    const response = await api.post<BidSummaryResponse>(`/api/reports/${bidId}/generate`, {});
    if (response.success && response.data) return response.data;
    throw new Error(response.error || 'Failed to generate report');
  },

  get: async (bidId: string): Promise<BidSummaryResponse & { generatedAt?: string }> => {
    const response = await api.get<{
      summary: string;
      totalSavings: number;
      percentageSaved: number;
      recommendation: string;
      generatedAt?: string;
    }>(`/api/reports/${bidId}`);
    if (response.success && response.data) {
      return {
        summary: response.data.summary,
        totalSavings: response.data.totalSavings,
        percentageSaved: response.data.percentageSaved,
        recommendation: response.data.recommendation,
        generatedAt: response.data.generatedAt,
      };
    }
    throw new Error(response.error || 'Report not found');
  },
};
